import { map } from "scripts/map/map";

export const SECTOR_RED_COLOR = '#ff6b6b';
export const SECTOR_YELLOW_COLOR = '#d7fe15';

export class Sector {
    public lat: number;
    public lng: number;
    public distance: number;
    public azimuth: number;
    public coneWidth: number;

    private sectorId: string;

    constructor(id: string | null, lat: number, lng: number, distance: number, azimuth: number, coneWidth: number) {
        this.lat = lat;
        this.lng = lng;
        this.distance = distance;
        this.azimuth = azimuth;
        this.coneWidth = coneWidth;

        this.sectorId = `sector-${id ?? "temp"}`;
    }

    public draw() {
        const polygon = this.getConePolygon();
        const data: GeoJSON.Feature<GeoJSON.Polygon> = {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [polygon]
            },
            properties: {}
        };

        if (!map.getSource(this.sectorId)) {

            map.addSource(this.sectorId, {
                type: "geojson",
                data
            });

            map.addLayer({
                id: this.sectorId,
                type: "fill",
                source: this.sectorId,
                paint: {
                    "fill-color": SECTOR_RED_COLOR,
                    "fill-opacity": 0.25
                }
            });

        }
    }

    public setSectorSelected() {
        if (map.getLayer(this.sectorId)) {
            map.setPaintProperty(this.sectorId, 'fill-color', SECTOR_YELLOW_COLOR);
        }
    }
    public setSectorDefault() {
        if (map.getLayer(this.sectorId)) {
            map.setPaintProperty(this.sectorId, 'fill-color', SECTOR_RED_COLOR);
        }
    }

    public remove() {
        if (map.getLayer(this.sectorId)) {
            map.removeLayer(this.sectorId);
        }

        // Удаляем источник
        if (map.getSource(this.sectorId)) {
            map.removeSource(this.sectorId);
        }
    }

    public redraw() {
        const polygon = this.getConePolygon();
        const data: GeoJSON.Feature<GeoJSON.Polygon> = {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [polygon]
            },
            properties: {}
        };
        const source = map.getSource(this.sectorId) as maplibregl.GeoJSONSource;
        source.setData(data);
    }


    private getConePolygon() {
        const points = [[this.lng, this.lat]];
        const half = this.coneWidth / 2;
        const steps = 40;

        for (let i = 0; i <= steps; i++) {

            const angle = this.azimuth - half + (this.coneWidth * i) / steps;
            const pt = this.pointAt(angle);

            points.push([pt.lng, pt.lat]);
        }

        points.push([this.lng, this.lat]);

        return points;
    }

    private pointAt(angle: number) {
        const R = 6371;
        const distance = this.distance / 1000;

        const lat1 = this.lat * Math.PI / 180;
        const lng1 = this.lng * Math.PI / 180;

        const br = angle * Math.PI / 180;

        const lat2 = Math.asin(
            Math.sin(lat1) * Math.cos(distance / R) +
            Math.cos(lat1) * Math.sin(distance / R) * Math.cos(br)
        );

        const lng2 =
            lng1 +
            Math.atan2(
                Math.sin(br) * Math.sin(distance / R) * Math.cos(lat1),
                Math.cos(distance / R) - Math.sin(lat1) * Math.sin(lat2)
            );

        return {
            lat: lat2 * 180 / Math.PI,
            lng: lng2 * 180 / Math.PI
        };
    }


    public calculateEndPoint() {
        const R = 6371; // Радиус Земли в км
        const lat1 = this.lat * Math.PI / 180;
        const lng1 = this.lng * Math.PI / 180;
        const bearing = this.azimuth * Math.PI / 180;
    
        const lat2 = Math.asin(
            Math.sin(lat1) * Math.cos(this.distance / R) +
            Math.cos(lat1) * Math.sin(this.distance / R) * Math.cos(bearing)
        );
    
        const lng2 = lng1 + Math.atan2(
            Math.sin(bearing) * Math.sin(this.distance / R) * Math.cos(lat1),
            Math.cos(this.distance / R) - Math.sin(lat1) * Math.sin(lat2)
        );
    
        return {
            lng: lng2 * 180 / Math.PI,
            lat: lat2 * 180 / Math.PI
        };
    }
}